import script from "./Last.vue?vue&type=script&setup=true&lang=js"
export * from "./Last.vue?vue&type=script&setup=true&lang=js"

import "./Last.vue?vue&type=style&index=0&id=e89a61e2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e89a61e2"]])

export default __exports__